import React, { useState, useEffect } from 'react';
import { Trash2, RefreshCw, User, Stethoscope, Pill } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../config';

const RecycleBin = () => {
  const [deletedItems, setDeletedItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // API_URL is now managed in src/config.js
  const fetchDeletedItems = async () => {
    try {
      const response = await axios.get(`${API_URL}?action=get_deleted_items`);
      if (Array.isArray(response.data)) {
        setDeletedItems(response.data);
      } else {
        setDeletedItems([]);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeletedItems();
  }, []);

  // Restore Logic
  const handleRestore = async (item) => {
      if(window.confirm(`Restore ${item.type}: ${item.name}?`)) {
          await axios.post(`${API_URL}?action=restore_item`, { id: item.id, type: item.type });
          alert("Item Restored Successfully.");
          fetchDeletedItems();
      }
  };

  // Permanent Delete Logic
  const handlePermanentDelete = async (item) => {
      if(window.confirm(`WARNING: This will PERMANENTLY DELETE "${item.name}".\n\nThis action cannot be undone. Are you sure?`)) {
          await axios.post(`${API_URL}?action=permanent_delete`, { id: item.id, type: item.type });
          fetchDeletedItems();
      }
  };

  // Helper for Icons
  const getTypeIcon = (type) => {
      if (type === 'Patient') return <User size={16} />;
      if (type === 'Doctor') return <Stethoscope size={16} />;
      if (type === 'Prescription') return <Pill size={16} />;
      return <Trash2 size={16} />;
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-700 flex items-center gap-3">
          <Trash2 className="text-red-600" size={30} />
          Recycle Bin
        </h2>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-red-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-bold text-red-800 uppercase">Source</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-red-800 uppercase">Item Details</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-red-800 uppercase">Date Deleted/Created</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-red-800 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {loading ? (
                <tr><td colSpan="4" className="text-center py-4">Loading deleted items...</td></tr>
            ) : deletedItems.length === 0 ? (
                <tr><td colSpan="4" className="text-center py-10 text-gray-400 italic">Recycle Bin is empty.</td></tr>
            ) : (
                deletedItems.map((item, index) => (
                <tr key={index} className="hover:bg-red-50 transition duration-150">
                    
                    {/* Column 1: Type (Patient/Doctor/RX) */}
                    <td className="px-6 py-4">
                        <span className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-bold
                            ${item.type === 'Patient' ? 'bg-blue-100 text-blue-800' : 
                              item.type === 'Doctor' ? 'bg-green-100 text-green-800' : 
                              'bg-yellow-100 text-yellow-800'}`}>
                            {getTypeIcon(item.type)} {item.type}
                        </span>
                    </td>

                    {/* Column 2: Name / Description */}
                    <td className="px-6 py-4 text-gray-800 font-medium">
                        {item.name}
                    </td>

                    {/* Column 3: Date */}
                    <td className="px-6 py-4 text-gray-500 text-sm">
                        {item.date}
                    </td>

                    {/* Column 4: Actions */}
                    <td className="px-6 py-4 flex justify-center gap-3">
                        <button 
                            onClick={() => handleRestore(item)} 
                            className="text-green-600 hover:text-green-800 bg-green-50 hover:bg-green-100 px-3 py-1.5 rounded flex items-center gap-1 transition text-sm font-bold"
                        >
                            <RefreshCw size={14} /> Restore
                        </button>
                        <button 
                            onClick={() => handlePermanentDelete(item)} 
                            className="text-red-600 hover:text-red-800 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded flex items-center gap-1 transition text-sm font-bold"
                        >
                            <Trash2 size={14} /> Delete
                        </button>
                    </td>
                </tr>
                ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecycleBin;